import {Injectable} from "@angular/core";
import {HttpHelperService} from "./http-helper.service";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(private httpService: HttpHelperService) {
  }
  public getValue(key: string) {
    return new Promise((resolve, reject) => {
      this.httpService.get<string>(`config/${key}`)
        .then((r: string) => {
          resolve(r);
        })
        .catch(e => reject(e));
    });
  }
}
